var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Down",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79287 0.29289C8.1834 -0.0976301 8.81656 -0.09763 9.20709 0.29289C9.59761 0.68342 9.59761 1.31658 9.20709 1.70711L2.91418 8L9.20709 14.2929C9.59761 14.6834 9.59761 15.3166 9.20709 15.7071C8.81656 16.0976 8.1834 16.0976 7.79287 15.7071L0.792884 8.7071C0.402384 8.3166 0.402384 7.68342 0.792885 7.29289L7.79287 0.29289Z",
    fill: "#A06056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow__left.69c03d5e6fe865e04e24f7e69d60a227.svg";
export { ForwardRef as ReactComponent };